import { jsx as t } from "react/jsx-runtime";
import { c as l } from "../clsx-OuTLNxxd.js";
const i = "FareCardBase-module_card__rJBNh",
  o = "FareCardBase-module_hilighted__PLa4z",
  m = "FareCardBase-module_full-height__NWoe6",
  c = "FareCardBase-module_content__M1Rkk",
  u = "FareCardBase-module_padding-small__ko1Sy",
  _ = "FareCardBase-module_padding-medium__GmLGb",
  e = {
    card: i,
    hilighted: o,
    fullHeight: m,
    content: c,
    paddingSmall: u,
    paddingMedium: _
  },
  p = _ref => {
    let {
      children: a,
      trackingName: d,
      hilighted: r = !1,
      fullHeight: n = !0,
      className: s
    } = _ref;
    return /* @__PURE__ */t("article", {
      className: l(e.card, {
        [e.hilighted]: r,
        [e.fullHeight]: n
      }, s),
      "data-content-name": d,
      children: a
    });
  },
  B = _ref2 => {
    let {
      padding: a = "default",
      children: d
    } = _ref2;
    return /* @__PURE__ */t("div", {
      className: l(e.content, {
        [e.paddingSmall]: a == "small",
        [e.paddingMedium]: a == "medium"
      }),
      children: d
    });
  };
export { p as FareCardBase, B as FareCardBaseContent };